import type { ReactElement, ReactNode } from "react";

import styles from "./Kbd.module.css";

export interface KbdProps {
  readonly children: ReactNode;
}

/** One key of a shortcut, drawn as the mockup's key cap (`kbd`). */
export function Kbd({ children }: KbdProps): ReactElement {
  return <kbd className={styles.kbd}>{children}</kbd>;
}
